import { useQuery } from '@tanstack/react-query'
import { fetchMe } from './api'
import type { UserCard } from './types'

export const meKey = ['auth', 'me'] as const

/**
 * Кто вошёл — один запрос на всё приложение.
 *
 * Спрашивается всегда, в том числе на экране входа: без учётной записи игра
 * работает целиком, поэтому «никто» — обычный ответ, а не повод показать
 * ошибку.
 */
export function useAuth(): { me: UserCard | null; loading: boolean } {
  const query = useQuery({
    queryKey: meKey,
    queryFn: fetchMe,
    staleTime: 60_000,
    retry: false,
  })

  return { me: query.data ?? null, loading: query.isPending }
}
